module.exports = __webpack_public_path__ + "534932c3a98ff60b453c472215772a89.png";